import { isRs } from "./currency";
import { DocumentoPreferencial, Passagem } from "./interfaces";

export function normalizePassagem(passagem: Passagem): Passagem {
  const adapter = (passagem.adaptador || "").toUpperCase();
  const isWebviagem = adapter === "WEBVIAGEM" || adapter === "GP-API";
  const deveUsarBpe = isRs(passagem.origemLabel, passagem.destinoLabel);

  return {
    ...passagem,
    grupo: passagem.grupo ?? "",
    conexoes: passagem.conexoes ?? [],
    classe: passagem.classe && passagem.classe.trim() !== "" ? passagem.classe : "CONVENCIONAL",
    provedorWebviagem: isWebviagem ? (passagem.provedorWebviagem ?? null) : null,
    viacao: deveUsarBpe ? {
      ...passagem.viacao,
      documento_preferencial: [DocumentoPreferencial.BPe],
      documento_preferencial_label: "BPE",
    } : passagem.viacao,
  };
}
